import { PlusOutlined, ReloadOutlined } from "@ant-design/icons"
import { Alert, Button, Empty, Skeleton } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

export function OverviewLoading() {
  const { t } = useTranslation()
  return (
    <div role={"status"} aria-label={t("settingsAutomation.overview.loading")}>
      <Skeleton active paragraph={{ rows: 4 }} />
    </div>
  )
}

export function OverviewLoadError({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation()
  return (
    <Alert
      type={"error"}
      showIcon
      message={t("settingsAutomation.overview.loadErrorTitle")}
      description={t("settingsAutomation.overview.loadErrorBody")}
      action={
        <Button icon={<ReloadOutlined />} size={"small"} onClick={onRetry}>
          {t("settingsAutomation.overview.retry")}
        </Button>
      }
    />
  )
}

function EmptyMessage({
  heading,
  guidance
}: {
  heading: string
  guidance: string
}) {
  return (
    <div className={"flex flex-col gap-1"}>
      <span className={"font-semibold text-gray-900"}>{heading}</span>
      <span className={"text-gray-500"}>{guidance}</span>
    </div>
  )
}

export function NoAutomations({ onCreate }: { onCreate?: () => void }) {
  const { t } = useTranslation()
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <EmptyMessage
          heading={t("settingsAutomation.overview.emptyTitle")}
          guidance={t("settingsAutomation.overview.emptyBody")}
        />
      }
    >
      {onCreate && (
        <Button type={"primary"} icon={<PlusOutlined />} onClick={onCreate}>
          {t("settingsAutomation.overview.newAutomation")}
        </Button>
      )}
    </Empty>
  )
}

export function NoMatches({
  query,
  onClear
}: {
  query: string
  onClear: () => void
}) {
  const { t } = useTranslation()
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <EmptyMessage
          heading={t("settingsAutomation.overview.noMatchesTitle", { query })}
          guidance={t("settingsAutomation.overview.noMatchesBody")}
        />
      }
    >
      <Button onClick={onClear}>
        {t("settingsAutomation.overview.clearSearch")}
      </Button>
    </Empty>
  )
}
